export const types = {
  SET_DEPARTMENT_ID: 'ticketTable/SET_DEPARTMENT_ID',
  SET_DISTRICT_ID: 'ticketTable/SET_DISTRICT_ID',
  SET_JOB_TICKET_NUMBER: 'ticketTable/SET_JOB_TICKET_NUMBER',
  SET_PAGE_SIZE: 'ticketTable/SET_PAGE_SIZE',
  SET_NEXT_CURSOR: 'ticketTable/SET_NEXT_CURSOR',
  SET_PREV_CURSOR: 'ticketTable/SET_PREV_CURSOR',
  SET_LEASE_ID: 'ticketTable/SET_LEASE_ID',
  SET_OPERATOR_ID: 'ticketTable/SET_OPERATOR_ID',
  SET_DATE_ORDER: 'ticketTable/SET_DATE_ORDER',
  SET_TABLE_ORDER: 'ticketTable/SET_TABLE_ORDER',
  SET_FILTERING_VALUES: 'ticketTable/SET_FILTERING_VALUES',
};

export const setDepartmentId = (departmentId) => {
  return {
    type: types.SET_DEPARTMENT_ID,
    departmentId,
  };
};

export const setDistrictId = (districtId) => {
  return {
    type: types.SET_DISTRICT_ID,
    districtId,
  };
};

export const setTicketNumber = (jobTicketNumber) => {
  return {
    type: types.SET_JOB_TICKET_NUMBER,
    jobTicketNumber,
  };
};

export const dispatchDistrict = (district) => {
  return setDistrictId(district.id);
};


export const dispatchDepartment = (department) => {
  return setDepartmentId(department.id);
};

export const setPageSize = (pageSize) => {
  return {
    type: types.SET_PAGE_SIZE,
    pageSize,
  };
};

export const setNextCursor = (nextCursor) => {
  return {
    type: types.SET_NEXT_CURSOR,
    nextCursor,
  };
};

export const setPrevCursor = (prevCursor) => {
  return {
    type: types.SET_PREV_CURSOR,
    prevCursor,
  };
};

export const setOperatorId = (operatorId) => {
  return {
    type: types.SET_OPERATOR_ID,
    operatorId,
  };
};

export const setLeaseId = (leaseId) => {
  return {
    type: types.SET_LEASE_ID,
    leaseId,
  };
};

export const dispatchOperator = (operator) => {
  return setOperatorId(operator.id);
};

export const dispatchLease = (lease) => {
  return setLeaseId(lease.id);
};

export const setDateOrder = (dateOrderBy) => {
  return {
    type: types.SET_DATE_ORDER,
    dateOrderBy,
  };
};

export const setTableOrder = (sorted) => {
  return {
    type: types.SET_TABLE_ORDER,
    sorted,
  };
};

// eslint-disable-next-line max-len
export const setFilteringValues = (formValues) => {
  return {
    type: types.SET_FILTERING_VALUES,
    ...formValues,
  };
};
